var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Electronics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 26.673,
    viewBox: "0 0 36 26.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38224",
    "data-name": "Path 38224",
    d: "M33.055,1.145a1.8,1.8,0,0,1,1.8,1.718V18.573H1.145V2.864A1.785,1.785,0,0,1,2.864,1.145ZM2.864,0A2.9,2.9,0,0,0,0,2.864V20.291a2.917,2.917,0,0,0,2.864,2.945h7.609v2.291H8.1v1.145H27.818V25.527H25.527V23.236h7.527A2.933,2.933,0,0,0,36,20.291V2.864A2.917,2.917,0,0,0,33.055,0ZM24.382,25.527H11.618V23.236H24.382Zm8.673-3.518H2.864a1.728,1.728,0,0,1-1.718-1.718v-.573H34.855v.573A1.747,1.747,0,0,1,33.055,22.009Z",
    fill: "#2b2a29",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/Electronics.c3ac0b89f7c931add75c59b844a61b75.svg";
export { ForwardRef as ReactComponent };